<style>
.echarts {
  width: 100%;
  height: 100%;
}

.active_table {
  width: 100%;
  height: 100%;
}

.ch {
  width: 80vw;
  height: 80vh;
  margin: 0 auto;
}
</style>

<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <div class="label">日期范围：</div>
        <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px; margin-right: 10px"
          @on-change="dateSelect($event)"></DatePicker>
        <div class="label">固废名称：</div>
        <Select v-model="search.wasteTypeId" style="width: 15em" placeholder="选择固废名称筛选" clearable>
          <Option v-for="item in wasteTypeList" :key="item.id" :value="item.id">{{ item.wasteName }} - {{
            item.wasteTypeName }}({{ item.wasteTypeCode }})</Option>
        </Select>
        <i-button type="default" @click="searchFunc" style="margin-left: 1em;">搜索</i-button>
        <router-link to="/waste/recordsCountDaySolid">
          <i-button type="info" style="margin-left: 1em;">一般固废统计</i-button>
        </router-link>
        <router-link to="/waste/recordsCountDay">
          <i-button type="info" style="margin-left: 1em;">危废统计</i-button>
        </router-link>
      </div>
    </toolbar>
    <div class="ch">
      <div>
        <h1>进出库记录日统计</h1>
      </div>
      <div>
        <v-chart autoresize :options="orgOptions" style="height: 60vh" />
      </div>
      <p></p>
    </div>
  </div>
</template>
 
<script>
import toolbar from "../toolBar.vue"; // 操作栏组件

export default {
  data() {
    return {
      orgOptions: {},
      // 查询
      search: {
        wasteTypeId: null,
        startDate: null,
        endDate: null,
      },
      allData: [],
      wasteTypeList: [], // 下拉列表
    };
  },
  components: {
    toolbar
  },
  created: function () {
    this.getWasteType(); // 下拉数据初始化
    this.getData();
  },
  methods: {
    // 获取固废类型
    getWasteType() {
      this.$api.Waste.getWasteTypeAll({ content: "" }, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.wasteTypeList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取固废类型失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    getData() {
      var that = this;
      // 获取数据
      this.$api.Waste.getWasteSolidStatistics3({ content: this.search }, [
        "uuid",
        "company",
      ]).then((res) => {
        if (res.code == 0) {
          this.allData = res.data;
          // 获取成功
          let topicList = []; // 标题
          let dataList1 = []; // 数据值1
          let dataList2 = []; // 数据值2
          this.allData.inlist.map((res) => {
            topicList.push(res.data);
            dataList1.push(res.count);
          });
          this.allData.outlist.map((res) => {
            dataList2.push(res.count);
          });

          this.orgOptions = {
            color: ["#3398DB"],
            tooltip: {
              trigger: "axis",
              formatter: function (params) {
                return (
                  params[0].name +
                  "<br/>入库重量:" + that.findCountByWasteName(params[0].name, 1) + "吨" +
                  "<br/>出库重量:" + that.findCountByWasteName(params[0].name, 2) + "吨"
                );
              },
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
              textStyle: {
                color: '#FFF', // 文本颜色
                fontSize: 14, // 文本字体大小
                fontWeight: 'bold', // 文本字体粗细
                align: 'left', // 文本左对齐
              },
            },
            legend: {
              data: ["入库", "出库"],
            },
            toolbox: {
              show: true,
              feature: {
                saveAsImage: {},
              },
            },
            xAxis: [
              {
                type: "category",
                name: "月份",
                boundaryGap: true,
                axisLabel: {
                  //底部文字倾斜
                  interval: 0,
                  rotate: 25,
                },
                data: topicList,
              },
            ],
            yAxis: [
              {
                type: "value",
              },
            ],
            series: [
              {
                name: "入库",
                type: "bar",
                data: dataList1,
                itemStyle: {
                  color: "#4285F4", // 蓝色
                },
              },
              {
                name: "出库",
                type: "bar",
                data: dataList2,
                itemStyle: {
                  color: "#FBBC05", // 蓝色
                },
              },
            ],
          };
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
        }
      });
    },
    // 选择时间
    dateSelect(date) {
      this.search.startDate = date[0];
      this.search.endDate = date[1];
      //console.log(this.search);
    },
    findCountByWasteName(_name, type) {
      let data = this.allData.inlist;
      if (type == 2) {
        data = this.allData.outlist;
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].data === _name) {
          return data[i].count;
        }
      }
      return 0;
    },
    // 搜索
    searchFunc() {
      this.getData();
    },
  },
};
</script>